import React, { useEffect, useState } from "react";
import { getAudits, deleteAudits } from "../services/firestoreService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import PageHead from "../components/common/PageHead";

const Audits = () => {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAudits = async () => {
      try {
        const data = await getAudits();
        setAudits(data || []);
      } catch (err) {
        setError("Failed to load audits.");
      } finally {
        setLoading(false);
      }
    };
    fetchAudits();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this audit?")) return;
    try {
      await deleteAudits(id);
      setAudits((prev) => prev.filter((a) => a.id !== id));
    } catch (err) {
      setError("Failed to delete audit.");
    }
  };

  const fmtDate = (ts) => {
    if (!ts) return "";
    if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleDateString();
    return new Date(ts).toLocaleDateString();
  };

  if (loading) return <p className="text-center mt-4">Loading audits...</p>;
  if (error) return <p className="text-center mt-4 text-red-500">{error}</p>;

  return (
    <>
      <PageHead name="Automation Audit Submissions" />
      <div className="container mx-auto p-6 max-w-screen-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
            <thead className="bg-gray-200 text-gray-700 text-lg">
              <tr>
                <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Name</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Email</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Company</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Interest</th>
                <th className="border border-gray-600 px-4 py-2 w-2/6">Notes</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Date</th>
                <th className="border border-gray-600 px-4 py-2 w-1/12">Action</th>
              </tr>
            </thead>
            <tbody>
              {audits.length > 0 ? (
                audits.map((audit, index) => (
                  <tr key={audit.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
                    <td className="h-20 px-4 border border-gray-600 text-center">{index + 1}</td>
                    <td className="h-20 px-4 border border-gray-600">{audit.name}</td>
                    <td className="h-20 px-4 border border-gray-600 break-words">{audit.email}</td>
                    <td className="h-20 px-4 border border-gray-600">{audit.company}</td>
                    <td className="h-20 px-4 border border-gray-600">{audit.interest}</td>
                    <td className="h-20 px-4 border border-gray-600 break-words max-w-xs">{audit.notes}</td>
                    <td className="h-20 px-4 border border-gray-600">{fmtDate(audit.timestamp)}</td>
                    <td className="h-20 px-4 border border-gray-600 text-center">
                      <button
                        onClick={() => handleDelete(audit.id)}
                        className="p-2 rounded text-red-500 hover:bg-red-500 hover:text-white"
                        title="Delete Audit"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">No audit submissions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Audits;
